<div class="card shadow-none d-flex flex-column h-100 p-4">
  <div class="d-flex flex-column h-100">
    <div class="d-flex flex-column flex-grow-1 overflow-auto" style="min-height: 0">
      <h2 class="h5 mb-3">Appointment History</h2>
      <groundworks-listbox-table [config]="tableConfig()" [items]="tableData()" [showSearch]="showSearch"
        [showPagination]="showPagination" (actionClick)="handleActionClick($event)" [actionLabel]="'Edit'" />
    </div>
    <div class="d-flex justify-content-end gap-2">
      @if (IsInsideSales() && !isPendingSale()) {
      <button class="btn btn-secondary" id="generateQuote-button" [disabled]="isDisabled()" (click)="generateQuote()">
        Generate New Quote
      </button>
      } @if (showRemoveFromFollowUpButton()) {
      <button class="btn btn-secondary" id="removeFromFollowUp-button" [disabled]="isDisabled()"
        (click)="removeFromFollowUpClick.emit()">
        Remove From Follow-Up
      </button>
      }

      <button class="btn btn-secondary" id="scheduleRevisit-button" [disabled]="isDisabled()"
        (click)="scheduleRevisitClick.emit()">
        {{ scheduleButtonLabel() }}
      </button>
    </div>
  </div>
</div>
